import { AppConfig } from './app.config';
var ɵ0 = function (config) { return function () { return config.load(); }; };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
